module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PassCode', {
    staticClass: "forceArea",
    attrs: {
      "forcePass": true
    },
    on: {
      "go-frash": _vm.goFrash
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a63e834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/passSet.vue
// module id = 1768
// module chunks = 1